import { render, staticRenderFns } from "./NftPayloadView.vue?vue&type=template&id=19c9e3a2&scoped=true&"
import script from "./NftPayloadView.vue?vue&type=script&lang=ts&"
export * from "./NftPayloadView.vue?vue&type=script&lang=ts&"
import style0 from "./NftPayloadView.vue?vue&type=style&index=0&id=19c9e3a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9e3a2",
  null
  
)

export default component.exports